import { transform, type QuoteResponseDTO } from "~/features/cart/activeQuote/transformers/quoteViewDataTransformer";
import type { TransformedCartData } from "~/features/cart/cart/transformers/CartResponseTransformer";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import type { QuoteCartViewDTO } from "../../cart/dto/QuoteCartViewDTO";

const apiUrl = resolveApiUrl("/quote/view");

export async function getData(): Promise<TransformedCartData> {
  const response = await fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  const oldDto: QuoteCartViewDTO = await response.json();
  const dto = preprocessData(oldDto);
  return transform(dto);
}

function preprocessData(dto: QuoteCartViewDTO): QuoteResponseDTO {
  return {
    code: dto.code,
    entries: dto.entries,
    dstError: dto.dstError,
    quoteAccount: dto.quoteAccount,
  };
}
